import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const getAuthToken = (state) => state.user.token

export const employeesApi = createApi({
    reducerPath: 'employeesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_BASE_URL,
        prepareHeaders: (headers, { getState }) => {

            const token = getAuthToken(getState())

            if (token) headers.set(`Authorization`, `Bearer ${token}`)

            return headers
        }
    }),
    endpoints: (builder) => ({

        getEmployees: builder.query({

            query: (queryPamramString) => `/api/employees/find?${queryPamramString}`,
            keepUnusedDataFor: 10

        })

    })
})

export const { useGetEmployeesQuery } = employeesApi